module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-rules"
  }, [_c('div', {
    staticClass: "rules-container"
  }, [_c('div', {
    staticClass: "bg-img"
  }), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "page-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "rules-nav"
  }, [_c('ul', {
    staticClass: "rules-nav-list"
  }, _vm._l((_vm.navItems), function(item, key) {
    return _c('li', {
      ref: "navItems",
      refInFor: true,
      staticClass: "rules-nav-item animate-items",
      class: ("item-" + (key+1))
    }, [_c('div', {
      staticClass: "nav-icon-wrapper"
    }, [_c('div', {
      staticClass: "nav-icon animate-img",
      class: ("icon-" + (key+1)),
      style: (("background-image: url(static/img/rules/icons/" + (key + 1) + ".png)"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "nav-text-wrapper"
    }, [_c('h5', {
      staticClass: "text animate-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "underline animate-line"
    }), _vm._v(" "), (item.popup) ? _c('a', {
      staticClass: "nav-item-link animate-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showVideoPopup(item.popup)
        }
      }
    }, [_vm._v(_vm._s(item.linkText))]) : _c('span', {
      on: {
        "click": function($event) {
          _vm.sendEvent(item)
        }
      }
    }, [_c('router-link', {
      staticClass: "nav-item-link animate-link",
      attrs: {
        "to": item.link
      }
    }, [_vm._v(" " + _vm._s(item.linkText))])], 1)])])
  })), _vm._v(" "), _c('a', {
    staticClass: "rules-link",
    attrs: {
      "href": "/static/rules/rules.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Полные правила")])]), _vm._v(" "), _c('div', {
    ref: "footballers",
    staticClass: "rules-footballers"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('h2', {
    ref: "title",
    staticClass: "title"
  }, [_vm._v("\n                    Футболисты,"), _c('br'), _vm._v("\n                    с которыми смогут сразиться"), _c('br'), _vm._v("\n                    победители конкурса\n                ")])]), _vm._v(" "), _c('ul', {
    staticClass: "rules-footballers-list"
  }, _vm._l((_vm.footballersItems), function(item, key) {
    return _c('li', {
      ref: "footballersItems",
      refInFor: true,
      staticClass: "rules-footballers-item animate-items",
      class: ("item-" + (key+1))
    }, [_c('div', {
      staticClass: "footballer-img-wrapper"
    }, [_c('div', {
      staticClass: "footballer-img animate-img",
      style: (("background-image: url(static/img/rules/footballers/" + (item.img) + ".png)"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "footballer-text-wrapper"
    }, [_c('h5', {
      staticClass: "footballer-text animate-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "underline animate-line"
    })])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19fe85b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Rules.vue
// module id = 492
// module chunks = 1